export const description =
  "PCAE (Plan de Compétitivité et d'Adaptation des Exploitations) : aide régionale FEADER pour modernisation de l'exploitation (bâtiments, équipements, ENR). Taux 20-40 %, bonus Jeune Agriculteur.";
